import { ActionType, createAction } from 'typesafe-actions';
import { IAccount } from '@models';

import { ProjectPickerActionTypes } from '@store/types';
import { IAccountProject } from '@models';

export const ProjectPickerActions = {
  updateAccountId: createAction(
    ProjectPickerActionTypes.UPDATE_ACCOUNT_ID,
    (accountId: string) => accountId,
    () => undefined
  )(),
  updateProjectPicker: createAction(
    ProjectPickerActionTypes.UPDATE_PICKER,
    (accountProject: IAccountProject) => accountProject,
    () => undefined
  )(),
  updateAccountsList: createAction(
    ProjectPickerActionTypes.UPDATE_ACCOUNTS_LIST,
    (accountsList: IAccount[]) => accountsList,
    () => undefined
  )(),
  requestProjectsList: createAction(
    ProjectPickerActionTypes.REQUEST_PROJECTS_LIST
  )(),
  updateProjectsList: createAction(
    ProjectPickerActionTypes.UPDATE_PROJECTS_LIST,
    (projectsList: IAccountProject[]) => projectsList,
    () => undefined
  )(),
};

export type ProjectPickerAction = ActionType<typeof ProjectPickerActions>;
